import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldDataIdentifier"],
  _excluded2 = ["fieldDataIdentifier"];
import FieldDataIdentifier from 'automation-ui-flow-core/fields/FieldDataIdentifier';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class FieldDataField extends createImmutableObjectClass({
  fieldDataIdentifier: null,
  valueType: 'FIELD_DATA'
}, {
  fromJSON: _ref => {
    let {
        fieldDataIdentifier
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      fieldDataIdentifier: new FieldDataIdentifier(fieldDataIdentifier || {})
    });
  },
  toJSON: _ref2 => {
    let {
        fieldDataIdentifier
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({}, rest, {
      fieldDataIdentifier: (fieldDataIdentifier === null || fieldDataIdentifier === void 0 ? void 0 : fieldDataIdentifier.toJSON()) || null
    });
  }
}) {
  /**
   * @deprecated Prefer dot notation: .fieldDataIdentifier
   */
  getIdentifier() {
    return this.fieldDataIdentifier;
  }
  getIsValueEmpty() {
    return !this.fieldDataIdentifier;
  }
  getValue() {
    return this.fieldDataIdentifier;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}